/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssueFieldScreensRoute } from '@jira/router-routes__admin-pages-screens-routes/src/globalSettingsIssueFieldScreensRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import ScreensPage, { LazyScreensPage } from './ui/spa/admin-pages/screens/screens-page/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsIssueFieldScreensRouteEntry: Route = createEntry(
	globalSettingsIssueFieldScreensRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.screens',
		// eslint-disable-next-line no-restricted-syntax
		component: ScreensPage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyScreensPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
